import React from "react";

export const PAYMENT_STEPS = [
  { key: "method", label: "Ödeme Yöntemi Seçimi" },
  { key: "payment", label: "Ödeme Bilgileri" },
  { key: "card", label: "Kart Bilgileri" },
  { key: "confirm", label: "Onay" },
];

export const PAYMENT_STEP_COUNT = PAYMENT_STEPS.length;

export const renderPaymentSteps = (activeStep) => (
  <div className="t-controlContactInfo-steps t-createPayment-steps">
    {PAYMENT_STEPS.map((step, index) => (
      <React.Fragment key={step.key}>
        <div
          className={`t-controlContactInfo-step${
            index === activeStep ? " t-controlContactInfo-step--active" : ""
          }${index < activeStep ? " t-controlContactInfo-step--completed" : ""}`}
        >
          <span className="t-controlContactInfo-stepNumber">{index + 1}</span>
          <span className="t-controlContactInfo-stepLabel">{step.label}</span>
        </div>
        {index < PAYMENT_STEPS.length - 1 && (
          <div className="t-controlContactInfo-stepLine" aria-hidden="true" />
        )}
      </React.Fragment>
    ))}
  </div>
);
